import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Arrow_Down } from 'UI/Icons';
import './Dropdown.scss';

var DropdownMenu = /*#__PURE__*/function (_Component) {
  _inherits(DropdownMenu, _Component);

  var _super = _createSuper(DropdownMenu);

  /* Setup */
  function DropdownMenu(props) {
    var _this;

    _classCallCheck(this, DropdownMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      document.querySelector('body').addEventListener('click', _this.onBodyClick);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      document.querySelector('body').removeEventListener('click', _this.onBodyClick);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      // Every time we update open
      if (_this.props.onChange) {
        _this.props.onChange(_this.state.open);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      _this.setState({
        open: !_this.state.open
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBodyClick", function (event) {
      var classList = event.target.classList;
      var parentClassList = event.target.parentElement.classList;
      var closest = event.target.closest('.dropdown');

      if (closest != null && closest.id != _this.id) {
        _this.setState({
          open: false
        }, function () {
          _this.onChange();
        });

        return event;
      }

      if (closest != null && closest.id == _this.id) {
        return event;
      }

      if (classList.contains('dropdown') || classList.contains('drop-down') || classList.contains('drop-down-icon')) {
        return event;
      }

      if (parentClassList.contains('dropdown') || parentClassList.contains('drop-down') || parentClassList.contains('drop-down-icon')) {
        return event;
      }

      if (_this.state.open) {
        _this.setState({
          open: false
        }, function () {
          _this.onChange();
        });
      }

      return event;
    });

    _defineProperty(_assertThisInitialized(_this), "menuContainerClick", function (event) {
      _this.setState({
        open: !_this.state.open
      }, function () {
        _this.onChange();
      });
    });

    _this.state = {
      open: false
    };
    _this.event = null;
    _this.id = 'dropdown-' + Math.floor(Math.random() * 100);
    return _this;
  }
  /* Component lifecycle methods */


  _createClass(DropdownMenu, [{
    key: "render",
    value:
    /* Render methods */
    function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "dropdown dropdown-left",
        id: this.id
      }, /*#__PURE__*/React.createElement("div", {
        id: "usermenubutton",
        "aria-haspopup": "true",
        "aria-expanded": this.state.open,
        className: "drop-down school-display-name user-display-name",
        onClick: this.onClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "drop-down-icon"
      }, this.props.icon, this.props.badge ? /*#__PURE__*/React.createElement("div", {
        className: "badge"
      }, /*#__PURE__*/React.createElement("span", null, this.props.badge)) : null), this.props.text != null ? /*#__PURE__*/React.createElement("span", {
        className: "name-text"
      }, this.props.text) : null, /*#__PURE__*/React.createElement(Arrow_Down, null)), /*#__PURE__*/React.createElement("div", {
        "aria-labelledby": "usermenubutton",
        className: "dropdown-menu",
        style: this.state.open ? {
          left: 'auto',
          right: 0
        } : {
          display: 'none'
        },
        onClick: this.menuContainerClick
      }, this.props.menuTitle != null ? /*#__PURE__*/React.createElement("h4", null, this.props.menuTitle) : null, this.props.children));
    }
  }]);

  return DropdownMenu;
}(Component);

export var DropdownItem = function DropdownItem(props) {
  if (props.divider) {
    return /*#__PURE__*/React.createElement("div", {
      className: "divider"
    });
  }

  if (props.target != null && props.target != '') {
    return /*#__PURE__*/React.createElement(Link, {
      className: "dropdown-item",
      to: props.target
    }, /*#__PURE__*/React.createElement("div", {
      className: "dropdown-menu-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dropdown-menu-item",
      to: props.target
    }, /*#__PURE__*/React.createElement("span", null, props.children))));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown-item",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-menu-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-menu-item"
  }, /*#__PURE__*/React.createElement("span", null, props.children))));
};
export default DropdownMenu;